import React from "react"
import { Select as MuiSelect, MenuItem } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const styles = makeStyles()(({ palette, spacing }) => ({
  select: {
    // minWidth: "150px",
    background: palette.mutes.light,
    borderRadius: 2,
    paddingLeft: spacing(3),
    paddingTop: spacing(2),
    paddingBottom: spacing(2)
  },
  icon: {
    color: palette.primary[500],
    fontSize: "20px",
    top: "auto"
  }
}))

interface Props {
  options: {
    label: string
    value: any
    disabled?: boolean
  }[]
  value: any
  onChange: (value: any) => void
  [key: string]: any
  disabledSelect: any
}

const Select: React.FC<React.PropsWithChildren<Props>> = props => {
  // Exclude `inline` (a non-DOM caller prop) from the spread so it isn't forwarded to the underlying <div> (React non-boolean-attribute warning)
  const { value, options, onChange, disabledSelect, inline, ...restProps } = props
  const { classes } = styles()

  return (
    <MuiSelect
      labelId="student-select-label"
      id="student-select"
      disableUnderline
      onChange={onChange}
      value={value}
      variant="standard"
      classes={{
        select: classes.select,
        icon: classes.icon
      }}
      {...restProps}
      disabled={disabledSelect && options.length === 1 ? true : false}
    >
      {options.map((option: any, index: number) => (
        <MenuItem
          key={index}
          value={option.value}
          selected
          disabled={option.disabled}
        >
          {option.label}
        </MenuItem>
      ))}
    </MuiSelect>
  )
}

export default Select
